<template>
<div id="app" class="gbwapps-page page-theme" :class="[pageThemeClass, { 'legal-page': page.legal }]">
  <HeadNav selectedLanguage="en" :page="pageName" :gotodownload="download" :apk="apk" />

  <main class="gbwapps-main" :class="{ 'legal-main': page.legal }">
    <article class="gbwapps-article" :class="{ 'legal-article': page.legal }">
      <template v-if="page.legal">
        <section class="content-section legal-card">
          <p v-for="paragraph in page.intro" :key="paragraph">
            <RichText :text="paragraph" />
          </p>
        </section>
      </template>

      <template v-else>
      <header class="article-hero page-hero">
        <p class="hero-eyebrow">{{ heroEyebrow }}</p>
        <h1>{{ page.title }}</h1>
        <p v-for="paragraph in page.intro" :key="paragraph">
          <RichText :text="paragraph" />
        </p>
        <button v-if="page.showDownload" class="primary-download" @click="download">
          <img src="@/assets/android.svg" alt="" class="android-icon">
          Download APK
        </button>
      </header>

      <section
        v-for="section in page.sections"
        :key="section.heading"
        class="content-section"
        :class="sectionClass(section)"
      >
        <h2><RichText :text="section.heading" /></h2>
        <p v-for="paragraph in section.paragraphs" :key="paragraph">
          <RichText :text="paragraph" />
        </p>

        <ul v-if="section.list && section.list.length" class="dot-list">
          <li v-for="item in section.list" :key="item">
            <RichText :text="item" />
          </li>
        </ul>

        <div
          v-if="section.table && section.table.length"
          class="table-wrap theme-table"
          :class="{ 'comparison-table': section.table[0].length > 2 }"
        >
          <table>
            <thead v-if="section.table[0].length > 2">
              <tr>
                <th v-for="col in section.table[0]" :key="col">{{ col }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, index) in section.table"
                :key="row.join('-')"
                v-show="section.table[0].length <= 2 || index > 0"
              >
                <template v-if="row.length <= 2">
                  <th>{{ row[0] }}</th>
                  <td>{{ row[1] }}</td>
                </template>
                <template v-else>
                  <td v-for="(cell, cellIndex) in row" :key="`${row[0]}-${cellIndex}`">{{ cell }}</td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="section.faqs && section.faqs.length" class="faq-list">
          <div v-for="faq in section.faqs" :key="faq[0]" class="faq-item">
            <h3>{{ faq[0] }}</h3>
            <p><RichText :text="faq[1]" /></p>
          </div>
        </div>
      </section>

      <RelatedModApps
        v-if="showRelatedMods"
        :current-key="pageName"
      />
      </template>
    </article>
  </main>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/gbwapps.scss';
import HeadNav from '@/components/HeadNav.vue';
import RichText from '@/components/RichText.vue';
import RelatedModApps from '@/components/RelatedModApps.vue';
import { articlePages, site } from '@/documents/gbwappsPages';

export default {
  name: 'GbwappsArticle',
  components: {
    HeadNav,
    RichText,
    RelatedModApps,
  },
  data() {
    return {
      site,
      apk: null,
      from: 'gb',
      filename: 'gb',
      selectedLanguage: 'en',
    };
  },
  computed: {
    pageName() {
      return this.$route.meta.pageKey || 'download';
    },
    page() {
      return articlePages[this.pageName] || articlePages.download;
    },
    pageThemeClass() {
      return `page-theme--${this.pageName}`;
    },
    heroEyebrow() {
      const labels = {
        download: 'Safe APK Download',
        blue: 'Blue WhatsApp Plus',
        fouad: 'Fouad WhatsApp',
        aero: 'Aero WhatsApp',
        old: 'Legacy Versions',
      };
      return labels[this.pageName] || this.site.name;
    },
    showRelatedMods() {
      return ['blue', 'fouad', 'aero'].includes(this.pageName);
    },
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else if (this.page.showDownload) {
      this.getOfficalApk();
    }
  },
  methods: {
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwapps.net',
          appName: appname || 'GB_gbwapps.net',
        })
        .then((res) => {
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    download() {
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
    sectionClass(section) {
      const heading = (section.heading || '').toLowerCase();
      if (section.faqs && section.faqs.length) return 'section-faq';
      if (section.table && section.table[0] && section.table[0].length > 2) return 'section-compare';
      if (section.table && section.table.length) return 'section-spec';
      if (section.list && section.list.length && heading.includes('feature')) return 'section-features';
      if (heading.includes('conclusion')) return 'section-conclusion';
      if (heading.includes('install') || heading.includes('download')) return 'section-guide';
      if (heading.includes('important') || heading.includes('note')) return 'section-notes';
      return 'section-prose';
    },
  },
};
</script>
